function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
/* SVGR has dropped some elements not supported by react-native-svg: title */
import * as React from 'react';
import { memo } from 'react';
import Svg, { Path } from 'react-native-svg';
const CaretRight = props => /*#__PURE__*/React.createElement(Svg, _extends({
  width: "12",
  height: "20",
  viewBox: "0 0 12 20",
  fill: "none"
}, props), /*#__PURE__*/React.createElement(Path, {
  d: "M0.22998 18.23L1.99998 20L12 10L1.99998 0L0.22998 1.77L8.45998 10L0.22998 18.23Z",
  fill: props && props.color ? props.color : '#0A4A8D'
}));
const CaretRightIcon = /*#__PURE__*/memo(CaretRight);
export default CaretRightIcon;
//# sourceMappingURL=index.js.map